module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb93721e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selectize.vue
// module id = 1864
// module chunks = 1